<template>
  <v-container>
    <v-layout text-xs-center wrap class='justify-center'>
      <v-flex mb-2 xs12>
        <h1 class="display-2 font-weight-bold">
          All Events
        </h1>
      </v-flex>

      <v-flex mb-4 v-for="event in events" :key="event.id" xs12 md6 lg4 class='justify-center' @click="navigateEvent(event)">
        <v-img :src="event.banner" class="mb-1" contain max-height="300"></v-img>
        {{event.title}}
        <br/>
        <v-btn v-if="event.coming_soon">Coming Soon!</v-btn>
        <v-flex v-if="!event.active">Opens {{event.start}}</v-flex>
        <v-btn v-if="event.active && !hasAttendee(event.id)"> 프로필 추가 등록 Register </v-btn>
        <v-btn v-if="event.active && hasAttendee(event.id)">신청 Select</v-btn>
      </v-flex>

    </v-layout>
    <v-snackbar
      v-model="snackbar"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      {{ text }}
      <v-btn
        color="pink"
        flat
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import {mapState} from 'vuex';

export default {
  data: () => ({
    snackbar: false,
    y: 'top',
    x: null,
    mode: '',
    timeout: 2000,
    text: "Event hasn't yet opened",
  }),
  beforeMount: async function() {
    await this.$store.dispatch('loadEvents');
    await this.$store.dispatch('loadAttendees');
  },
  computed: {
    ...mapState(['myprofile', 'events', 'attendees']),
  },
  methods: {
    hasAttendee(event_id) {
      if (
        !!this.attendees?.find(x => {
          return x.event_id == event_id;
        })
      ) {
        return true;
      } else {
        return false;
      }
    },
    navigateEvent(event) {
      if (event.active) {
        if (this.hasAttendee(event.id)) {
          this.$router.push(`/events/${event.id}`);
        } else {
          this.$router.push(`/events/register/swing/${event.id}`);
        }
      } else {
        this.$data.snackbar = true;
      }
    },
  },
};
</script>

<style>
</style>
